import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {PermittedAppsMapper} from '../mappers/permitted-apps.mapper';

@Injectable({
    providedIn: 'root'
})
export class PermittedAppsUseCase {
    constructor(
        private mapper: PermittedAppsMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run(userId) {
      return this.data.getPermittedApps(userId).pipe(this.mapper.map);
    }
}
